import React, { useState, useEffect, useRef } from "react";

import { Link, useHistory } from "react-router-dom";
// import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardText, CardBody, CardTitle, CardHeader, CardFooter, Button, } from 'reactstrap';
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import classnames from 'classnames';
import Config from "../../Config.js";
import Moment from "moment";
import swal from "sweetalert";
import TextareaAutosize from "react-textarea-autosize";
import Multiselect from "multiselect-react-dropdown";
// import { default as ReactSelect } from "react-select";
// import { components } from "react-select";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Checkchatisenabled } from "../../api/packageApi";
import {
  MultipleDeleteEmailChatRoomid,
  DeleteemailChatRoomid,
  CleraEmailChatRoomid,
  HideEmailChatRoomid,
} from "../../api/chatApi.js";
// import ScrollToBottom ,{useScrollToEnd}from 'react-scroll-to-bottom';

const UserEmailchat = () => {
  const chatContainer = React.createRef();
  const chathideContainer = React.createRef();
  let history = useHistory();
  const [chatdetailslist, setchatdetailslist] = useState(null);
  const [description, setdescription] = useState("");
  const [descriptionError, setdescriptionError] = useState("");
  const [selectchatroomid, setselectchatroomid] = useState([]);
  const [isLoadingmultiple, setisLoadingmultiple] = React.useState(false);
  const [isLoadingmultipleDelete, setisLoadingmultipleDelete] =
    React.useState(false);
  const [isLoading, setisLoading] = React.useState(false);
  const [ProductinfoModel, setProductinfoModel] = React.useState(false);
  const [chatdproductinfo, setchatdproductinfo] = useState(null);
  const [userdata, setuserdata] = useState([]);
  const [productdatadata, setproductdatadata] = useState([]);

  const [chatinfo, setchatinfo] = useState([]);
  const [chatinfoTemp, setchatinfoTemp] = useState([]);

  const [selectedOptionsproduct, setSelectedOptionsproduct] = useState([]);
  const [selectedOptionsuser, setSelectedOptionsuser] = useState([]);
  const [chatallselect, setChatallselect] = useState(false);

  // const [ishidedata, setishidedata] = React.useState(false);

  const [chathidedetailslist, setchathidedetailslist] = useState(null);
  useEffect(() => {
    async function fetchMyAPI() {
      let checkLogin = localStorage.getItem("loginUserID");
      if (
        checkLogin === "" ||
        checkLogin === null ||
        checkLogin === "null" ||
        checkLogin === undefined
      ) {
        history.push("/Login");
      } else {
        let response = await Checkchatisenabled();
        if (response === true || response === "true") {
          GetAllchat();
          getalluser([]);
          getallproduct([]);
        }
      }
    }
    fetchMyAPI();
  }, []);

  const GetAllchat = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "emailChatMessage/WebemailChatUserListByUserCompanyID",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then(async (resp1) => {
      resp1.json().then(async (result) => {
        if (result !== null && result.length > 0) {
          setchatinfo(result);
          setchatinfoTemp(result);
          // setactiveTargetID()
          getallchatdetails(result[0]?.roomID);
          await getallHidechatdetails(result[0]?.roomID);
        } else {
          setchatinfo([]);
          setchatinfoTemp([]);
        }
      });
    });
  };

  const getalluser = async (productlist) => {
    try {
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");

      fetch(
        Config.apiUrl + "emailChatMessage/GetemailChatUserListByUserCompanyID",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(productlist),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 !== null) {
            let data = selectedOptionsuser.find((o) => o.value === "*");
            if (data !== null && data !== undefined && data !== "") {
              setSelectedOptionsuser([{ label: "All", value: "*" }, ...resp1]);
            }
            setuserdata(resp1);
          } else {
            setuserdata([]);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getallproduct = async (userlist) => {
    try {
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");

      fetch(
        Config.apiUrl +
          "emailChatMessage/GetEmailChatProductListByUserCompanyID",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(userlist),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 !== null) {
            setproductdatadata(resp1);
            let data = selectedOptionsproduct.find((o) => o.value === "*");
            if (data !== null && data !== undefined && data !== "") {
              setSelectedOptionsproduct([
                { label: "All", value: "*" },
                ...resp1,
              ]);
            }
          } else {
            setproductdatadata([]);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllchatwithTimer = () => {
    console.log("new Date", new Date());
    let loginid = localStorage.getItem("loginUserID");
    let EmaptyArrry = [];
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "emailChatMessage/WebemailChatUserListByUserCompanyID",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setchatinfo(result);
        setchatinfoTemp(result);
      });
    });
  };

  const getallHidechatdetails = async (Roomid) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (Roomid !== null && Roomid !== "" && Roomid !== undefined) {
      try {
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebGetEmailHideChatMessageListByRoomId?roomId=" +
            Roomid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((resp1) => {
          resp1.json().then((result) => {
            setchathidedetailslist(result);
            var el = document.getElementById("EmailHidemessagesID");
            if (el) {
              el.scrollTop = el.scrollHeight;
            }
          });
        });
      } catch (error) {
        console.log("error =>", error);
      }
    } else {
      setchathidedetailslist(null);
      console.log("Roomid Empty");
    }
  };

  const getallchatdetails = (Roomid) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (Roomid !== null && Roomid !== "" && Roomid !== undefined) {
      ReadMessage(Roomid);
      try {
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebGetEmailChatMessageListByRoomId?roomId=" +
            Roomid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((resp1) => {
          resp1.json().then((result) => {
            setchatdetailslist(result);
            var el = document.getElementById("EmailmessagesID");
            if (el) {
              el.scrollTop = el.scrollHeight;
            }
          });
        });
      } catch (error) {
        console.log("error =>", error);
      }
    } else {
      setchatdetailslist(null);
      console.log("Roomid Empty");
    }
  };
  const ReadMessage = (Roomid) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    try {
      fetch(
        Config.apiUrl +
          "emailChatMessage/WebIsReadMessageEmailchat?roomId=" +
          Roomid,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result?.responseType === "Success") {
            GetAllchatwithTimer();
          }
        });
      });
    } catch (error) {
      console.log("error =>", error);
    }
  };
  const onChangeDescription = (event) => {
    setdescription(event.target.value);
    setdescriptionError("");
  };
  const sendmessage = (targetID) => {
    if (targetID !== null) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      if (
        description === null ||
        description === "" ||
        description === undefined
      ) {
        return;
      }
      let chatmodel = {
        userCompanyId: chatdetailslist?.chatMessageRoomDetail.toUserCompanyID,
        description: description,
        isDeleted: false,
        roomID: chatdetailslist?.chatMessageRoomDetail?.roomID,
      };

      fetch(Config.apiUrl + "emailChatMessage/adminsendEmailChatMessage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(chatmodel),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp?.issucces) {
            setdescription("");
            getallchatdetails(chatdetailslist?.chatMessageRoomDetail?.roomID);
          } else {
            setdescription("");
            getallchatdetails(chatdetailslist?.chatMessageRoomDetail?.roomID);
            swal("error!", resp?.message, {
              icon: "error",
            });
          }
        });
      });
    }
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      //GetAllchatwithTimer();
      if (chatdetailslist !== null) {
        getallchatdetails(chatdetailslist?.chatMessageRoomDetail?.roomID);
      }
    }, 2000);
    return () => clearInterval(intervalId);
  }, []);
  const ExportDeatlisRoomId = (e) => {
    e.preventDefault();
    try {
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");
      let roomid = chatdetailslist?.chatMessageRoomDetail?.roomID;
      if (roomid !== null && roomid !== "" && roomid !== undefined) {
        setTimeout(() => {
          setisLoading(true);
        }, 300);
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebExportEmailChatMessagesByRoomId?roomId=" +
            roomid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => response.blob())
          .then((blob) => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "Exportchat.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => {
              setisLoading(false);
            }, 300);
          });
      } else {
        swal("Sorry!", "no chat found", "error");
      }
    } catch (error) {
      setTimeout(() => {
        setisLoading(false);
      }, 300);
    }
  };

  const ExportDeatlisRoomIdPdfFile = (e) => {
    e.preventDefault();
    try {
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");
      let roomid = chatdetailslist?.chatMessageRoomDetail?.roomID;
      if (roomid !== null && roomid !== "" && roomid !== undefined) {
        setTimeout(() => {
          setisLoading(true);
        }, 300);
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebExportPdfEmailChatMessagesByRoomId?roomId=" +
            roomid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => response.blob())
          .then((blob) => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "Exportchat.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => {
              setisLoading(false);
            }, 300);
          });
      } else {
        swal("Sorry!", "no chat found", "error");
      }
    } catch (error) {
      setTimeout(() => {
        setisLoading(false);
      }, 300);
    }
  };

  const onProductinfoclose = () => {
    setProductinfoModel(false);
  };
  const onProductinfo = (e) => {
    e.preventDefault();
    try {
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");
      let targetID = chatdetailslist?.chatMessageRoomDetail?.targetID;
      let targetType = chatdetailslist?.chatMessageRoomDetail?.targetType;
      if (
        targetType == "articleemailchat" ||
        targetType == "productemailchat"
      ) {
        if (targetType == "articleemailchat") {
          targetType = "articlechat";
        } else if (targetType == "productemailchat") {
          targetType = "productchat";
        }
        fetch(
          Config.apiUrl +
            "ArticleProduct/GetArticlebychat?id=" +
            targetID +
            "&TargetType=" +
            targetType,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1?._id !== null) {
              console.log("resp1informationProduct==>", resp1);
              setProductinfoModel(true);
              setchatdproductinfo(resp1);
            } else {
              swal("Sorry!", "Your item not found", "error");
              setchatdproductinfo(null);
            }
          });
      }
    } catch (error) {}
  };
  const handleChangeRoomid = (roomid) => {
    let selecttemproomid = [...selectchatroomid];
    let test = selecttemproomid.includes(roomid);
    if (test === true) {
      selecttemproomid = selecttemproomid.filter((x) => x !== roomid);
    } else {
      selecttemproomid.push(roomid);
    }
    if (chatinfo.length === selecttemproomid.length) {
      setChatallselect(true);
    } else {
      setChatallselect(false);
    }
    setselectchatroomid(selecttemproomid);
  };
  const handleChangeAllselect = () => {
    if (chatallselect === false) {
      let AllRoomid = [];
      if (chatinfo.length > 0) {
        chatinfo.map((item) => {
          let roomid = item?.emailChatMessageRoomDetail?.roomID;
          AllRoomid.push(roomid);
        });
        //let selecttemproomid = [...selectchatroomid];
        setselectchatroomid(AllRoomid);
        setChatallselect(true);
      }
    } else {
      setChatallselect(false);
      setselectchatroomid([]);
    }
  };

  const ExportDeatlismultipleRoomId = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    try {
      if (selectchatroomid.length > 0) {
        setisLoadingmultiple(true);
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebExportemailChatMessagesBymultipleRoomId",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
            body: JSON.stringify(selectchatroomid),
          }
        )
          .then((response) => response.blob())
          .then((blob) => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "Exportchat.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            setisLoadingmultiple(false);
          });
      } else {
        swal("Sorry!", "select User", "error");
      }
    } catch (error) {
      setisLoadingmultiple(false);
    }
  };

  const ExportPdfFileDeatlismultipleRoomId = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    try {
      if (selectchatroomid.length > 0) {
        setisLoadingmultiple(true);
        fetch(
          Config.apiUrl +
            "emailChatMessage/WebExportPdfChatMessagesBymultipleRoomId",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
            body: JSON.stringify(selectchatroomid),
          }
        )
          .then((response) => response.blob())
          .then((blob) => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "AllExportchat.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            setisLoadingmultiple(false);
          });
      } else {
        swal("Sorry!", "select User", "error");
      }
    } catch (error) {
      setisLoadingmultiple(false);
    }
  };
  const SelectedDeleteRoomID = () => {
    if (selectchatroomid.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this chat !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          setisLoadingmultipleDelete(true);
          let response = await MultipleDeleteEmailChatRoomid(selectchatroomid);
          if (response?.responseType === "Success") {
            GetAllchat();
            getalluser([]);
            getallproduct([]);
            swal("Congratulations! Your data deleted successfully.", {
              icon: "success",
            });
          } else {
            swal("Your data  is safe!");
          }
          setisLoadingmultipleDelete(false);
        }
      });
    }
  };
  const DeleteRoomID = () => {
    let RoomID = chatdetailslist?.chatMessageRoomDetail?.roomID;
    if (RoomID !== null && RoomID !== "" && RoomID !== undefined) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this chat !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let response = await DeleteemailChatRoomid(RoomID);
          if (response?.responseType === "Success") {
            GetAllchat();
            getalluser([]);
            getallproduct([]);
            swal("Congratulations! Your data deleted successfully.", {
              icon: "success",
            });
          } else {
            swal("Your data  is safe!");
          }
        }
      });
    }
  };

  const HideallchatbyRoomID = () => {
    let RoomID = chatdetailslist?.chatMessageRoomDetail?.roomID;
    if (RoomID !== null && RoomID !== "" && RoomID !== undefined) {
      swal({
        title: "Are you sure?",
        text: "Once Hide, you will not be able to recover this chat !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let response = await HideEmailChatRoomid(RoomID);
          if (response?.responseType === "Success") {
            // await GetAllchatwithTimer();
            getallchatdetails(RoomID);
            await getallHidechatdetails(RoomID);
            swal("Congratulations! Your data Hide successfully.", {
              icon: "success",
            });
          } else {
            swal("Your data  is safe!");
          }
        }
      });
    }
  };

  const ClearchatbyRoomID = () => {
    let RoomID = chatdetailslist?.chatMessageRoomDetail?.roomID;
    if (RoomID !== null && RoomID !== "" && RoomID !== undefined) {
      swal({
        title: "Are you sure?",
        text: "Once clear, you will not be able to recover this chat !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let response = await CleraEmailChatRoomid(RoomID);
          if (response?.responseType === "Success") {
            await GetAllchatwithTimer();
            await getallchatdetails(RoomID);
            swal("Congratulations! Your data deleted successfully.", {
              icon: "success",
            });
          } else {
            swal("Your data  is safe!");
          }
        }
      });
    }
  };

  const GoToProductinformationPage = (ProductID, Type) => {
    if (ProductID !== null && ProductID !== "" && ProductID !== undefined) {
      if (Type === true) {
        history.push({
          pathname: "/product-information",
          state: {
            ProductID: ProductID,
            TargetID: chatdetailslist?.chatMessageRoomDetail?.qrCodeID,
          },
        });
      } else {
        history.push({
          pathname: "/article-infopage",
          state: { ProductID: ProductID },
        });
      }
    }
  };

  const getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  };
  const getDropdownButtonLabeluser = ({ placeholderButtonLabel, value }) => {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  };

  const onChangeproduct = (value, event) => {
    if (event.action === "select-option" && event.option.value === "*") {
      let SelectedList = productdatadata.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getalluser(SelectedList);
      }
      setSelectedOptionsproduct([
        { label: "All", value: "*" },
        ...productdatadata,
      ]);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      getalluser([]);
      setSelectedOptionsproduct([]);
    } else if (event.action === "deselect-option") {
      let data = value.filter((o) => o.value !== "*");
      let SelectedList = data.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getalluser(SelectedList);
      }
      setSelectedOptionsproduct(value.filter((o) => o.value !== "*"));
    } else if (value.length === productdatadata.length) {
      setSelectedOptionsproduct([
        { label: "All", value: "*" },
        ...productdatadata,
      ]);
      let SelectedList = productdatadata.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getalluser(SelectedList);
      }
    } else {
      let SelectedList = value.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getalluser(SelectedList);
      }
      setSelectedOptionsproduct(value);
    }
  };
  const onChangeuser = (value, event) => {
    if (event.action === "select-option" && event.option.value === "*") {
      let SelectedList = userdata.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getallproduct(SelectedList);
      }
      setSelectedOptionsuser([{ label: "All", value: "*" }, ...userdata]);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      getallproduct([]);
      setSelectedOptionsuser([]);
    } else if (event.action === "deselect-option") {
      let data = value.filter((o) => o.value !== "*");
      let SelectedList = data.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getallproduct(SelectedList);
      }
      setSelectedOptionsuser(value.filter((o) => o.value !== "*"));
    } else if (value.length === userdata.length) {
      let SelectedList = userdata.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getallproduct(SelectedList);
      }
      setSelectedOptionsuser([{ label: "All", value: "*" }, ...userdata]);
    } else {
      let SelectedList = value.map((r) => r.value);
      if (
        SelectedList !== null &&
        SelectedList !== undefined &&
        SelectedList !== ""
      ) {
        getallproduct(SelectedList);
      }
      setSelectedOptionsuser(value);
    }
  };

  const onitemsearch = () => {
    let chatinfoobj = [...chatinfoTemp];
    let selectproductdata = selectedOptionsproduct.filter(
      (o) => o.value !== "*"
    );
    if (selectproductdata !== null && selectproductdata.length > 0) {
      let productid = selectproductdata.map((r) => r.value);
      let data = [];
      chatinfoobj
        .filter((item) =>
          productid.includes(item?.emailChatMessageDetail?.targetID)
        )
        .map((subitem) => {
          data.push(subitem);
        });
      console.log("dataProduct", data);
      chatinfoobj = data;
    }
    let selecuserdata = selectedOptionsuser.filter((o) => o.value !== "*");
    if (selecuserdata !== null && selecuserdata.length > 0) {
      let userid = selecuserdata.map((r) => r.value);
      console.log("userid", userid);
      let data = [];
      chatinfoobj
        .filter((item) => userid.includes(item.fromUserEmail))
        .map((subitem) => {
          data.push(subitem);
        });
      console.log("datauser", data);
      chatinfoobj = data;
    }
    setchatinfo(chatinfoobj);
  };

  const ClereHedersearch = async (e) => {
    e.preventDefault();
    let chatinfoobj = [...chatinfoTemp];
    setchatinfo(chatinfoobj);
    setSelectedOptionsproduct([]);
    setSelectedOptionsuser([]);
    getalluser([]);
    getallproduct([]);
  };
  return (
    <>
      <div>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              {/* <a href="/dashboard/home">Home</a> */}
              <a href="/home">Home</a>
            </li>

            <li className="breadcrumb-item active">Client Emails</li>
          </ol>
          <h1 className="page-header">Client Emails</h1>
          <div className="container-fluid">
            {chatinfo?.length > 0 ? (
              <div className="d-flex align-items-center mb-3 flex-wrap gap-3">
                <div>
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={(e) => {
                      onitemsearch();
                    }}
                  >
                    {" "}
                    <i class="fa fa-search m-r-5"></i>Search
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-yellow"
                    onClick={(e) => {
                      ClereHedersearch(e);
                    }}
                  >
                    <i class="fa fa-search m-r-5"></i> Reset
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-green"
                    onClick={(e) => {
                      //ExportDeatlismultipleRoomId(e);
                      ExportPdfFileDeatlismultipleRoomId(e);
                    }}
                  >
                    {isLoadingmultiple === true ? (
                      <i
                        class="fas fa-sync fa-spin m-r-5"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                    )}
                    Export{" "}
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-danger"
                    onClick={(e) => {
                      // alert("coming soon");
                      SelectedDeleteRoomID();
                    }}
                  >
                    {isLoadingmultipleDelete === true ? (
                      <i
                        class="fas fa-sync fa-spin m-r-5"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fas  fa-sm fa-fw m-r-5 fa-trash icon"></i>
                    )}
                    Delete{" "}
                  </button>
                </div>

                {/* <div
                  style={{
                    textAlign: "right",
                    flex: "auto",
                    justifyContent: "right",
                  }}
                >
                  {ishidedata ? (
                    <button
                      className="btn btn-dark"
                      onClick={(e) => {
                        setishidedata(false);
                      }}
                    >
                      <i class="fa fa-eye icon fa-lg"></i> Unhide{" "}
                    </button>
                  ) : (
                    <button
                      className="btn btn-dark"
                      onClick={(e) => {
                        setishidedata(true);
                      }}
                    >
                      <i class="fa fa-eye-slash icon fa-lg"></i> Hide{" "}
                    </button>
                  )}
                </div> */}
              </div>
            ) : (
              <></>
            )}
            {chatinfo?.length > 0 ? (
              <div className="row">
                <div className="col-lg-6">
                  <div className=" bg-white px-3 py-3 h-100">
                    <div className="row align-items-center pb-2 border-bottom border-dark">
                      <div className="col-xl-6">
                        <div className="">
                          <ReactMultiSelectCheckboxes
                            width="100%"
                            options={[
                              { label: "All", value: "*" },
                              ...productdatadata,
                            ]}
                            placeholderButtonLabel="Select product"
                            getDropdownButtonLabel={getDropdownButtonLabel}
                            value={selectedOptionsproduct}
                            onChange={onChangeproduct}
                            setState={setSelectedOptionsproduct}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="">
                          <ReactMultiSelectCheckboxes
                            width="100%"
                            options={[
                              { label: "All", value: "*" },
                              ...userdata,
                            ]}
                            placeholderButtonLabel="Select user"
                            getDropdownButtonLabel={getDropdownButtonLabeluser}
                            value={selectedOptionsuser}
                            onChange={onChangeuser}
                            setState={setSelectedOptionsuser}
                          />
                        </div>
                      </div>
                    </div>
                    {chatinfo?.length > 0 && (
                      <div className="form-check mr-2  mt-3">
                        <input
                          className="form-check-input checkbox-label mt-2"
                          type="checkbox"
                          checked={chatallselect}
                          onChange={(e) => {
                            handleChangeAllselect();
                          }}
                        />
                        <label className="form-check-label ml-2">
                          Select All
                        </label>
                      </div>
                    )}

                    <div className="chatsub-section">
                      {chatinfo?.length > 0 ? (
                        chatinfo?.map((item, i) => (
                          <div className="d-flex align-items-center  mt-3">
                            <div className="form-check mr-2">
                              <input
                                className="form-check-input checkbox-label"
                                type="checkbox"
                                onChange={(e) => {
                                  handleChangeRoomid(
                                    item?.emailChatMessageRoomDetail?.roomID
                                  );
                                }}
                                checked={
                                  selectchatroomid.includes(
                                    item?.emailChatMessageRoomDetail?.roomID
                                  ) === true
                                    ? true
                                    : false
                                }
                                id={item?.emailChatMessageRoomDetail?.roomID}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={
                                  item?.emailChatMessageRoomDetail?.roomID
                                }
                              ></label>
                            </div>
                            <div
                              className="chat-msg-container"
                              style={{
                                backgroundColor:
                                  item?.emailChatMessageDetail?.isRead === false
                                    ? "#00acac"
                                    : "white",
                                //backgroundColor: "#00acac",
                              }}
                              key={i}
                              onClick={(e) => {
                                // setishidedata(false);
                                getallchatdetails(
                                  item?.emailChatMessageRoomDetail?.roomID
                                );
                                getallHidechatdetails(
                                  item?.emailChatMessageRoomDetail?.roomID
                                );
                              }}
                            >
                              <div className="left-header-container">
                                <div className="chat-header-icon">
                                  {item?.profilePicture ? (
                                    <img
                                      alt=""
                                      src={
                                        Config.contentUrl + item?.profilePicture
                                      }
                                      className="width-40 height-40 f-s-20 text-center  rounded-corner"
                                    />
                                  ) : (
                                    <img
                                      alt=""
                                      src="/assets/img/user/NoProfile.png"
                                      className="width-40 height-40 f-s-20 text-center  rounded-corner"
                                    />
                                  )}
                                </div>
                                <div className="chat-header-content">
                                  <div className="d-flex">
                                    <h4 className="chat-header-title">
                                      {item?.fromUserName} <br />
                                      {item?.fromUserEmail}
                                    </h4>
                                  </div>
                                  <p className="chat-header-desc text text1line">
                                    {item?.emailChatMessageDetail?.description}
                                  </p>
                                </div>
                              </div>
                              <div className="w-25px">
                                <h6 className="text-center">
                                  {Moment(
                                    item?.emailChatMessageDetail?.createdDate
                                  ).format("DD-MM-YYYY")}
                                </h6>
                                <h6 className="text-center">
                                  {Moment(
                                    item?.emailChatMessageDetail?.createdDate
                                  ).format("hh:mm A")}
                                </h6>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                <>
                  {chatdetailslist !== null && chatdetailslist !== undefined ? (
                    <div className="col-lg-6">
                      <div className="container-fluid chat-container">
                        <div className="chat-header align-itens-center">
                          <div className="left-header-container">
                            <div className="chat-header-icon">
                              <img
                                alt=""
                                src="/assets/img/user/NoProfile.png"
                                className="width-40 height-40 f-s-20 text-center  rounded-corner"
                              />
                            </div>
                            <div className="chat-header-content">
                              <h4
                                className="chat-header-title"
                                id="_usernameemail_"
                              >
                                {chatdetailslist?.toUserCompanyDetail?.name}{" "}
                                <br />
                                {
                                  chatdetailslist?.toUserCompanyDetail?.email
                                }{" "}
                              </h4>
                              <p className="chat-header-desc"></p>
                            </div>
                          </div>

                          <div className="right-header-container d-flex ">
                            <button
                              className="btn btn-green mr-2 "
                              onClick={(e) => {
                                ExportDeatlisRoomIdPdfFile(e);
                              }}
                            >
                              {isLoading === true ? (
                                <i
                                  class="fas fa-sync fa-spin m-r-5"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                              )}
                              Export Pdf{" "}
                            </button>

                            <button
                              className="btn btn-danger mr-2 menu-item"
                              onClick={(e) => {
                                onProductinfo(e);
                              }}
                            >
                              <i class="fas  fa-sm fa-fw m-r-5 fa-info-circle icon"></i>
                              info !
                            </button>
                            <UncontrolledButtonDropdown direction={"right"}>
                              <DropdownToggle
                                className="btn btn-warning ellipsis-btn btn-sm"
                                direction={"right"}
                              >
                                <i
                                  class="fa fa-ellipsis-v"
                                  aria-hidden="true"
                                ></i>
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem
                                  onClick={(e) => {
                                    HideallchatbyRoomID();
                                  }}
                                >
                                  Hide all
                                </DropdownItem>
                                <DropdownItem divider></DropdownItem>
                                <DropdownItem
                                  onClick={(e) => {
                                    ClearchatbyRoomID();
                                  }}
                                >
                                  Clear Chat
                                </DropdownItem>
                                <DropdownItem divider></DropdownItem>
                                <DropdownItem
                                  onClick={(e) => {
                                    DeleteRoomID();
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledButtonDropdown>
                          </div>
                        </div>

                        <div
                          className="chat-body-container"
                          ref={chatContainer}
                          id="EmailmessagesID"
                        >
                          {chatdetailslist?.chatList?.length > 0 &&
                            chatdetailslist?.chatList?.map((item, i) =>
                              item.toUserCompanyId ===
                                localStorage.getItem("loginUserID") &&
                              (item.fromUserEmail === "" ||
                                item.fromUserEmail === null) ? (
                                <div className="row mb-3 justify-content-end">
                                  <div className="col-xxl-6 col-lg-12"></div>
                                  <div className="col-xxl-6 col-lg-12">
                                    <div className="chat-item with-media right">
                                      <div className="chat-info">
                                        <div className="right-chat-info-container">
                                          <div className="chat-message">
                                            {item?.description}{" "}
                                          </div>
                                          <div className="chat-time">
                                            {Moment(item?.createdDate).format(
                                              "hh:mm A"
                                            )}{" "}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="chat-media">
                                        <img
                                          src={
                                            Config.contentUrl +
                                            item?.touserProfilePicture
                                          }
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src =
                                              "/assets/img/user/NoProfile.png";
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row mb-3">
                                  <div className="col-xxl-6 col-lg-12">
                                    <div className="chat-item with-media left">
                                      <div className="chat-media">
                                        <img
                                          alt=""
                                          src="/assets/img/user/NoProfile.png"
                                        />
                                      </div>
                                      <div className="chat-info">
                                        <div className="left-chat-info-container">
                                          <div className="chat-message">
                                            {item?.description}
                                          </div>
                                          <div className="chat-time">
                                            {Moment(item?.createdDate).format(
                                              "hh:mm A"
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                        <div className="widget-input widget-input-rounded">
                          <form
                            action="javascript:void(0);"
                            method="POST"
                            name=""
                          >
                            <div className="input-container">
                              <div className="input-box ">
                                <TextareaAutosize
                                  minRows={2}
                                  maxRows={6}
                                  placeholder="Write a message..."
                                  value={description}
                                  onChange={(e) => {
                                    onChangeDescription(e);
                                  }}
                                />
                              </div>
                              <button
                                type="button"
                                class="btn btn-dark "
                                onClick={() => {
                                  sendmessage(
                                    chatdetailslist?.chatMessageRoomDetail
                                      ?.targetID
                                  );
                                }}
                              >
                                <i class="ion ion-md-send"></i>
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </>

                {/* {ishidedata ? (
                  <>
                    {chathidedetailslist !== null &&
                    chathidedetailslist !== undefined ? (
                      <div className="col-lg-6">
                        <div className="container-fluid chat-container">
                          <div className="chat-header align-itens-center">
                            <div className="left-header-container">
                              <div className="chat-header-icon">
                                <img
                                  alt=""
                                  src="/assets/img/user/NoProfile.png"
                                  className="width-40 height-40 f-s-20 text-center  rounded-corner"
                                />
                              </div>
                              <div className="chat-header-content">
                                <h4
                                  className="chat-header-title"
                                  id="_usernameemail_"
                                >
                                  {
                                    chathidedetailslist?.toUserCompanyDetail
                                      ?.name
                                  }{" "}
                                  <br />
                                  {
                                    chathidedetailslist?.toUserCompanyDetail
                                      ?.email
                                  }{" "}
                                </h4>
                                <p className="chat-header-desc"></p>
                              </div>
                            </div>
                          </div>

                          <div
                            className="chat-body-container"
                            ref={chathideContainer}
                            id="EmailHidemessagesID"
                          >
                            {chathidedetailslist?.chatList?.length > 0 &&
                              chathidedetailslist?.chatList?.map((item, i) =>
                                item.toUserCompanyId ===
                                  localStorage.getItem("loginUserID") &&
                                (item.fromUserEmail === "" ||
                                  item.fromUserEmail === null) ? (
                                  <div className="row mb-3 justify-content-end">
                                    <div className="col-xxl-6 col-lg-12"></div>
                                    <div className="col-xxl-6 col-lg-12">
                                      <div className="chat-item with-media right">
                                        <div className="chat-info">
                                          <div className="right-chat-info-container">
                                            <div className="chat-message">
                                              {item?.description}{" "}
                                            </div>
                                            <div className="chat-time">
                                              {Moment(item?.createdDate).format(
                                                "hh:mm A"
                                              )}{" "}
                                            </div>
                                          </div>
                                        </div>

                                        <div className="chat-media">
                                          <img
                                            src={
                                              Config.contentUrl +
                                              item?.touserProfilePicture
                                            }
                                            onError={({ currentTarget }) => {
                                              currentTarget.onerror = null;
                                              currentTarget.src =
                                                "/assets/img/user/NoProfile.png";
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="row mb-3">
                                    <div className="col-xxl-6 col-lg-12">
                                      <div className="chat-item with-media left">
                                        <div className="chat-media">
                                          <img
                                            alt=""
                                            src="/assets/img/user/NoProfile.png"
                                          />
                                        </div>
                                        <div className="chat-info">
                                          <div className="left-chat-info-container">
                                            <div className="chat-message">
                                              {item?.description}
                                            </div>
                                            <div className="chat-time">
                                              {Moment(item?.createdDate).format(
                                                "hh:mm A"
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                          <div className="widget-input widget-input-rounded">
                            <form
                              action="javascript:void(0);"
                              method="POST"
                              name=""
                            >
                              <div className="input-container">
                                <div className="input-box ">
                                  <TextareaAutosize
                                    minRows={2}
                                    maxRows={6}
                                    placeholder="Write a message..."
                                    value=""
                                    disabled
                                  />
                                </div>
                                <button
                                  type="button"
                                  class="btn btn-dark "
                                  disabled
                                >
                                  <i class="ion ion-md-send"></i>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {chatdetailslist !== null &&
                    chatdetailslist !== undefined ? (
                      <div className="col-lg-6">
                        <div className="container-fluid chat-container">
                          <div className="chat-header align-itens-center">
                            <div className="left-header-container">
                              <div className="chat-header-icon">
                                <img
                                  alt=""
                                  src="/assets/img/user/NoProfile.png"
                                  className="width-40 height-40 f-s-20 text-center  rounded-corner"
                                />
                              </div>
                              <div className="chat-header-content">
                                <h4
                                  className="chat-header-title"
                                  id="_usernameemail_"
                                >
                                  {chatdetailslist?.toUserCompanyDetail?.name}{" "}
                                  <br />
                                  {
                                    chatdetailslist?.toUserCompanyDetail?.email
                                  }{" "}
                                </h4>
                                <p className="chat-header-desc"></p>
                              </div>
                            </div>

                            <div className="right-header-container d-flex ">
                              <button
                                className="btn btn-green mr-2 "
                                onClick={(e) => {
                                  ExportDeatlisRoomIdPdfFile(e);
                                }}
                              >
                                {isLoading === true ? (
                                  <i
                                    class="fas fa-sync fa-spin m-r-5"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                                )}
                                Export Pdf{" "}
                              </button>

                              <button
                                className="btn btn-danger mr-2 menu-item"
                                onClick={(e) => {
                                  onProductinfo(e);
                                }}
                              >
                                <i class="fas  fa-sm fa-fw m-r-5 fa-info-circle icon"></i>
                                info !
                              </button>
                              <UncontrolledButtonDropdown direction={"right"}>
                                <DropdownToggle
                                  className="btn btn-warning ellipsis-btn btn-sm"
                                  direction={"right"}
                                >
                                  <i
                                    class="fa fa-ellipsis-v"
                                    aria-hidden="true"
                                  ></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={(e) => {
                                      HideallchatbyRoomID();
                                    }}
                                  >
                                    Hide all
                                  </DropdownItem>
                                  <DropdownItem divider></DropdownItem>
                                  <DropdownItem
                                    onClick={(e) => {
                                      ClearchatbyRoomID();
                                    }}
                                  >
                                    Clear Chat
                                  </DropdownItem>
                                  <DropdownItem divider></DropdownItem>
                                  <DropdownItem
                                    onClick={(e) => {
                                      DeleteRoomID();
                                    }}
                                  >
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledButtonDropdown>
                            </div>
                          </div>

                          <div
                            className="chat-body-container"
                            ref={chatContainer}
                            id="EmailmessagesID"
                          >
                            {chatdetailslist?.chatList?.length > 0 &&
                              chatdetailslist?.chatList?.map((item, i) =>
                                item.toUserCompanyId ===
                                  localStorage.getItem("loginUserID") &&
                                (item.fromUserEmail === "" ||
                                  item.fromUserEmail === null) ? (
                                  <div className="row mb-3 justify-content-end">
                                    <div className="col-xxl-6 col-lg-12"></div>
                                    <div className="col-xxl-6 col-lg-12">
                                      <div className="chat-item with-media right">
                                        <div className="chat-info">
                                          <div className="right-chat-info-container">
                                            <div className="chat-message">
                                              {item?.description}{" "}
                                            </div>
                                            <div className="chat-time">
                                              {Moment(item?.createdDate).format(
                                                "hh:mm A"
                                              )}{" "}
                                            </div>
                                          </div>
                                        </div>

                                        <div className="chat-media">
                                          <img
                                            src={
                                              Config.contentUrl +
                                              item?.touserProfilePicture
                                            }
                                            onError={({ currentTarget }) => {
                                              currentTarget.onerror = null;
                                              currentTarget.src =
                                                "/assets/img/user/NoProfile.png";
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="row mb-3">
                                    <div className="col-xxl-6 col-lg-12">
                                      <div className="chat-item with-media left">
                                        <div className="chat-media">
                                          <img
                                            alt=""
                                            src="/assets/img/user/NoProfile.png"
                                          />
                                        </div>
                                        <div className="chat-info">
                                          <div className="left-chat-info-container">
                                            <div className="chat-message">
                                              {item?.description}
                                            </div>
                                            <div className="chat-time">
                                              {Moment(item?.createdDate).format(
                                                "hh:mm A"
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                          <div className="widget-input widget-input-rounded">
                            <form
                              action="javascript:void(0);"
                              method="POST"
                              name=""
                            >
                              <div className="input-container">
                                <div className="input-box ">
                                  <TextareaAutosize
                                    minRows={2}
                                    maxRows={6}
                                    placeholder="Write a message..."
                                    value={description}
                                    onChange={(e) => {
                                      onChangeDescription(e);
                                    }}
                                  />
                                </div>
                                <button
                                  type="button"
                                  class="btn btn-dark "
                                  onClick={() => {
                                    sendmessage(
                                      chatdetailslist?.chatMessageRoomDetail
                                        ?.targetID
                                    );
                                  }}
                                >
                                  <i class="ion ion-md-send"></i>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )} */}
              </div>
            ) : (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src="../assets/img/empty.png" alt="" height="200px" />
              </div>
            )}
          </div>

          <Modal isOpen={ProductinfoModel} toggle={onProductinfoclose}>
            <ModalHeader toggle={onProductinfoclose} className="modalheader">
              <h4 className="text-white mb-0">Product information</h4>
            </ModalHeader>
            <ModalBody>
              <div>
                {chatdproductinfo !== null &&
                  chatdproductinfo !== undefined && (
                    <div className="container">
                      <div className="row  align-items-center">
                        <div className="col-xl-6">
                          <img
                            src={
                              Config.contentUrl +
                              chatdproductinfo?.articleImage[0]?.filePath
                            }
                            style={{ width: "100%", height: "100%" }}
                            className="img-responsive img-rounded"
                          />

                          <h5 className="m-t-10 mb-0 text-center">
                            {chatdproductinfo?.articleName}
                          </h5>
                        </div>
                        <div className="col-xl-6">
                          <div className="">
                            <p>
                              <b>Article</b>&nbsp;
                              {chatdproductinfo?.articleNumber}
                            </p>
                            <p>
                              <b>Category</b>&nbsp;
                              {chatdproductinfo?.categoryID
                                ? chatdproductinfo?.categorydetail?.name +
                                  " / " +
                                  chatdproductinfo?.subCategoryDetail?.name
                                : "N/A"}
                            </p>
                            <p>
                              <b>Type</b>&nbsp;
                              {chatdproductinfo?.isProduct == true
                                ? "Production"
                                : "Article"}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="row  justify-content-center">
                        <button
                          type="button"
                          className="btn-lg shadow-add my-3 btn btn-warning"
                          onClick={(e) => {
                            GoToProductinformationPage(
                              chatdproductinfo?._id,
                              chatdproductinfo?.isProduct
                            );
                          }}
                        >
                          Detail
                        </button>
                      </div>
                    </div>
                  )}
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default UserEmailchat;
